module.exports = __webpack_public_path__ + "img/PEAKY-LION.39c52ed9.jpg";